// apps/dashboard/src/components/OnboardingStep.tsx
// Compact single-step row used inside OnboardingChecklist.

import { cn } from '@/lib/cn';
import { CheckCircle2, Circle } from 'lucide-react';

interface OnboardingStepProps {
  label: string;
  isCompleted: boolean;
  isCurrent: boolean;
}

export function OnboardingStep({ label, isCompleted, isCurrent }: OnboardingStepProps) {
  return (
    <div className="flex items-center gap-2 py-0.5">
      {isCompleted ? (
        <CheckCircle2 className="h-3.5 w-3.5 shrink-0 text-green-500" />
      ) : (
        <Circle
          className={cn(
            'h-3.5 w-3.5 shrink-0',
            isCurrent ? 'text-primary' : 'text-muted-foreground/50',
          )}
        />
      )}
      <span
        className={cn(
          'text-xs leading-none',
          isCompleted && 'line-through text-muted-foreground',
          isCurrent && !isCompleted && 'font-medium text-foreground',
          !isCompleted && !isCurrent && 'text-muted-foreground/70',
        )}
      >
        {label}
      </span>
    </div>
  );
}
